import React from 'react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { PartnerCTA } from '../components/PartnerCTA';
export function TermsOfServicePage() {
  return <>
      <PageHero title="Terms of Service" data-id="element-1518" />

      <Breadcrumbs items={[{
      label: 'Terms of Service'
    }]} data-id="element-1519" />

      <section className="bg-white py-24" data-id="element-1520">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 prose prose-lg text-steel-600" data-id="element-1521">
          <p data-id="element-1522">Last updated: February 2025</p>
          <h3 data-id="element-1523">1. Introduction</h3>
          <p data-id="element-1524">
            These terms and conditions govern your use of the Chiltern Global
            website. By accessing this website, you accept these terms and
            conditions in full.
          </p>
          <h3 data-id="element-1525">2. Intellectual Property Rights</h3>
          <p data-id="element-1526">
            Unless otherwise stated, Chiltern Global Ltd and/or its licensors
            own the intellectual property rights in the website and material on
            the website. Subject to the license below, all these intellectual
            property rights are reserved.
          </p>
          <h3 data-id="element-1527">3. License to Use Website</h3>
          <p data-id="element-1528">
            You may view, download for caching purposes only, and print pages
            from the website for your own personal use, subject to the
            restrictions set out below and elsewhere in these terms and
            conditions.
          </p>
          <p data-id="element-1529">You must not:</p>
          <ul data-id="element-1530">
            <li data-id="element-1531">
              Republish material from this website (including republication on
              another website).
            </li>
            <li data-id="element-1532">Sell, rent or sub-license material from the website.</li>
            <li data-id="element-1533">
              Reproduce, duplicate, copy or otherwise exploit material on this
              website for a commercial purpose.
            </li>
          </ul>
          <h3 data-id="element-1534">4. Limitations of Liability</h3>
          <p data-id="element-1535">
            Chiltern Global Ltd will not be liable to you (whether under the law
            of contact, the law of torts or otherwise) in relation to the
            contents of, or use of, or otherwise in connection with, this
            website for any direct, indirect, special or consequential loss.
          </p>
          <h3 data-id="element-1536">5. Governing Law</h3>
          <p data-id="element-1537">
            These terms and conditions will be governed by and construed in
            accordance with English law, and any disputes relating to these
            terms and conditions will be subject to the exclusive jurisdiction
            of the courts of England and Wales.
          </p>
        </div>
      </section>

      <PartnerCTA data-id="element-1538" />
    </>;
}